module.exports = "/v2/pages/dashboard/dist/9c74e172f87984c48ddf5c8108cabe67.png";